// Knowledge base for the "Chat with me" widget.
//
// Content lives in knowledgeBase.data.json (so a Node build script and the
// browser can share it). The Cloudflare Worker reads the whole thing and
// answers each question with a model; the browser only uses `entries` for the
// offline keyword safety net.
//
// After editing knowledgeBase.data.json:
//   npm run build:kb           # regenerates chat-worker/src/knowledge.js
//   cd chat-worker && npm run deploy

import data from './knowledgeBase.data.json';

export const KNOWLEDGE_BASE = data.entries;
export const STARTER_QUESTIONS = data.starters;
export const KB_CONTEXT = data.context;

export const KB_BY_ID = KNOWLEDGE_BASE.reduce((map, entry) => {
  map[entry.id] = entry;
  return map;
}, {});

export const NO_MATCH_MESSAGE =
  "I don't have enough information to answer that accurately. Feel free to message Ehsan directly through the website's form or email him at ehsan.faghih72@gmail.com — he would love to answer you.";

export const FALLBACK_UNAVAILABLE_MESSAGE =
  "The assistant is offline for a moment and I don't have a prepared answer for that. You can reach Ehsan directly through the website's form or at ehsan.faghih72@gmail.com.";
